export default __webpack_public_path__ + "static/icon-29-6-3818dbc483979721161a2d04a10da291.png";